import { FieldArrayRenderProps } from 'formik'
import { DateTimePicker } from 'components/Forms'
import { Button } from 'ui'
import { DayPickerMulti } from './DayPickerMulti'
import { DayHourToggle } from './DayHourToggle'

import { t } from 'translations'
import { RangeByHour } from './types'

interface PremiumRangeByHourProps {
  value: RangeByHour
  setFieldValue: <T>(field: T) => void
  setFieldTouched: (field: string, isTouched: boolean) => void
  isSubmitting: boolean
  isValidating: boolean
  index: number
  arrayHelpers: FieldArrayRenderProps
}

export const PremiumRangeByHour: React.FC<PremiumRangeByHourProps> = ({
  setFieldValue,
  setFieldTouched,
  isSubmitting,
  isValidating,
  value,
  index,
  arrayHelpers
}) => {
  return (
    <>
      <div className="d-flex flex-row justify-content-between">
        <div className="d-flex flex-row">
          <DayHourToggle value={value.type} index={index} />
          <div className="mx-2 mt-2">{t('administration.wagePremiums.form.FROM')}</div>
          <DayPickerMulti
            name={`assignBasedOnTheseRanges[${index}].days`}
            value={value.days}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            isSubmitting={isSubmitting}
            isValidating={isValidating}
          />
          <div className="ml-2">
            <DateTimePicker
              module="administration.wagePremiums.form"
              name={`assignBasedOnTheseRanges[${index}].startTime`}
              type="time"
              style={{ width: 95 }}
              defaultValue="00:00"
              hideDescription
              hideLabel
            />
          </div>
          <div className="mx-2 mt-2">{t('administration.wagePremiums.form.TO')}</div>
          <div className="ml-2" style={{ width: 95 }}>
            <DateTimePicker
              module="administration.wagePremiums.form"
              name={`assignBasedOnTheseRanges[${index}].endTime`}
              type="time"
              style={{ width: 95 }}
              defaultValue="00:00"
              hideDescription
              hideLabel
            />
          </div>
        </div>
        <div className="d-flex flex-row">
          <Button
            outlined
            className="mx-2 btn"
            onClick={event => {
              event.preventDefault()
              arrayHelpers.remove(index)
            }}
          >
            <i className="fas fa-trash-can" />
          </Button>
        </div>
      </div>
    </>
  )
}
